import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';

const SpaceContentDivider: React.FC = () => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div className="py-6 md:py-10">
      <div className={classNames('border-b', hasDarkBg ? 'border-white/20' : 'border-black/20')} />
    </div>
  );
};

export default SpaceContentDivider;
